import { render } from "./WizardTabs.vue?vue&type=template&id=188fda91&scoped=true"
import script from "./WizardTabs.vue?vue&type=script&lang=js"
export * from "./WizardTabs.vue?vue&type=script&lang=js"

import "./WizardTabs.css?vue&type=style&index=0&id=188fda91&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188fda91"]])

export default __exports__